<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6">
      <div class="bg-white shadow-sm-light">
        <app-info-appel [base]="'application'" [cohorte]="cohorte"></app-info-appel>

        <div class="border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/candidatures/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd" />
                </svg>

                Candidatures
              </a>
            </li>

            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/admis/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                    clip-rule="evenodd" />
                </svg>

                Admis
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/test/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group">
                <svg class="w-6 h-6 text-blue-600 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd" />
                </svg>
                Test&nbsp;d'admission
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/statconnection/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center whitespace-nowrap p-4 text-gray-600 border-b-2 hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300">
                <svg class="w-2 h-6 text-gray-600 dark:text-white mr-2 shrink-0" id="icon" viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M30,30H22V4h8Zm-6-2h4V6H24Z"></path>
                  <path d="M20,30H12V12h8Z"></path>
                  <path d="M10,30H2V18h8Z"></path>
                  <rect data-name="<Transparent Rectangle>" id="_Transparent_Rectangle_"></rect>
                </svg>

                Statistiques de connexion
              </a>
            </li>

          </ul>
        </div>
        <div class="w-full p-1 bg-white delib-screen admis flex-col justify-start items-start gap-2.5 inline-flex">
          <div class="w-full p-8 bg-white flex-col justify-start items-start gap-2.5 inline-flex">
            <div class="self-stretch h-full flex-col justify-start items-start gap-5 flex">
              <div class="self-stretch flex-col justify-start items-center gap-1 flex">
                <div class="self-stretch flex-col justify-start items-start gap-1 flex">
                  <div class="self-stretch h-[66px] flex-col justify-start items-start gap-1 flex">
                    <div class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex">
                      <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                        <div class="self-stretch text-center text-gray-900 text-3xl font-semibold mt-5">
                          Tests d'admission
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Graphe Repartitions -->
                <div class="w-full p-1 justify-start items-end gap-2.5 inline-flex">
                  <div class="flex w-full">
                    <div class="mt-4 w-full">
                      <canvas id="canvasTest"></canvas>
                    </div>
                  </div>
                </div>

                <div class="w-full inline-flex py-5 justify-center items-end gap-5">
                  <button type="file"
                    class="text-sm font-semibold text-white mat-mdc-input-element bg-green-500 self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                    (click)="exportTableOfStats()">
                    Exporter les statistiques en XLS
                  </button>
                  <button type="file"
                    class="text-sm font-semibold text-white mat-mdc-input-element bg-green-500 self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                    (click)="exportTableOfList()">
                    Exporter la liste en XLS
                  </button>
                  <!-- <button
            type="submit"
            class="w-fit text-white mat-mdc-input-element bg-red-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
            (click)="exportPDF()"
          >
            Exporter en PDF
          </button>
        </div> -->
                </div>

                <div class="self-stretch tab-recap-admis tableau-ctnr flex-col justify-start items-center gap-4 flex">
                  <!-- Old Table -->
                  <!--   <table  id="tableauAdmis" class="mat-elevation-z8 w-full text-sm tableau text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead class="text-sm inter-medium font-medium f12 bg-light-gray text-gray-700">
                      <tr>
                          <th scope="row" class="px-6 py-3">IUF</th>
                          <th scope="row" class="px-6 py-3">Prénom(s)</th>
                          <th scope="row" class="px-6 py-3">Nom</th>
                          <th scope="row" class="px-6 py-3">Age</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 ng-star-inserted" *ngFor="let admis of AllAdmis ">
                          <td scope="row" class="px-6 py-3 inter-medium font-medium text-gray-900 whitespace-nowrap dark:text-white" >{{admis.iuf}}</td>
                          <td scope="row" class="px-6 py-3 inter-regular f14">{{admis.firstName}}</td>
                          <td scope="row" class="px-6 py-3 inter-regular f14">{{admis.lastName}}</td>
                          <td scope="row" class="px-6 py-3 inter-regular f14">{{admis.age +" ans"}}</td>
                      </tr>
                  </tbody>
              </table> -->
                  <mat-form-field style="width: -webkit-fill-available">
                    <mat-label class="text-sm">Recherche</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input />
                  </mat-form-field>

                  <div
                    class="mat-elevation-z8 w-full text-sm tableau text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <table id="testQualificationList" mat-table [dataSource]="dataSource" matSort>
                      <!-- ID Column -->
                      <!-- <ng-container matColumnDef="iuf">
                <th
                  *matHeaderCellDef
                  mat-sort-header
                  class="px-6 py-3 text-3xl f12 bg-light-gray text-gray-700"
                >
                  IUF
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="px-6 py-3 inter-medium font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ row.iuf }}
                </td>
              </ng-container> -->

                      <!-- Progress Column -->
                      <ng-container matColumnDef="prenom">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-6 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Prénom(s)
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-6 py-3 inter-regular f14 text-sm font-medium">
                          {{ row.firstName }}
                        </td>
                      </ng-container>

                      <!-- Name Column -->
                      <ng-container matColumnDef="nom">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-2 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Nom
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-2 py-3 inter-regular f14 text-sm font-medium">
                          {{ row.lastName }}
                        </td>
                      </ng-container>

                      <!-- Fruit Column -->
                      <ng-container matColumnDef="age">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-2 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Age
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-2 py-3 inter-regular f20 text-sm font-medium">
                          {{ row.age }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="genre">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-2 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Genre
                        </th>

                        <td mat-cell *matCellDef="let row" class="px-2 py-3 inter-regular f14 text-sm font-medium">
                          {{ row.gender }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="mail">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-2 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Email
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-2 py-3 inter-regular f14 text-sm font-medium">
                          <!-- <div
                    class="sm etat pastille rounded-lg p-1 text-white w-fit text-center"
                    [style.backgroundColor]="
                      row.mailSent == true ? '#79D99C' : '#f04438'
                    "
                    [style.color]="row.mailSent == true ? '#027A48' : '#ffffff'"
                  >
                    {{ row.mailSent == true ? "Oui" : "Non" }}
                  </div> -->
                          {{ row.mail }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="choice">
                        <th *matHeaderCellDef mat-sort-header
                          class="px-2 py-3 text-sm f12 bg-greyLighter text-gray-700">
                          Choix de certificat
                        </th>
                        <td mat-cell *matCellDef="let row" class="px-2 py-3 inter-regular f14">
                          <div *ngIf="cohorte != 'SIG2402-FODE'"
                            class="etat pastille rounded-lg p-1 px-2 text-white w-fit text-sm text-center"
                            [style.backgroundColor]="
                              row.choice_certif != 'Pas de choix'
                                ? '#79D99C'
                                : '#f04438'
                            " [style.color]="
                              row.choice_certif != 'Pas de choix'
                                ? '#027A48'
                                : '#ffffff'
                            ">
                            {{ row.choice_certif }}
                          </div>
                          <!----->
                          <div *ngIf="cohorte == 'SIG2402-FODE'"
                            class="etat pastille rounded-lg p-1 px-2 text-white w-fit text-sm text-center"
                            [style.backgroundColor]="
                              row.testChoice != 'Pas de choix'
                                ? '#79D99C'
                                : '#f04438'
                            " [style.color]="
                              row.testChoice != 'Pas de choix'
                                ? '#027A48'
                                : '#ffffff'
                            ">
                            {{ row.testChoice }}
                          </div>
                        </td>
                      </ng-container>

                      <!-- <ng-container matColumnDef="actions">
                <th
                  *matHeaderCellDef
                  mat-sort-header
                  class="px-6 py-3 text-2xl f12 bg-light-gray text-gray-700"
                >
                  Actions
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="px-6 py-3 inter-regular f14"
                >
                  <button
                    (click)="toggleModalDetails(row)"
                    class="focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6 text-gray-800 dark:text-white"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  </button>
                </td>
              </ng-container> -->
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">
                          No data matching the filter "{{ input.value }}"
                        </td>
                      </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200]"
                      aria-label="Select page of users"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>